/**
 * Simple event handlers that don't require complex logic
 * These can be reused across components
 */

/**
 * Creates a toggle handler for boolean state
 * @param {Function} setState - State setter function
 * @returns {Function} Toggle handler
 */
export const createToggleHandler = (setState) => () => {
  try {
    setState((prev) => !prev);
  } catch (error) {
    console.error("Error in toggle handler:", error);
  }
};

/**
 * Creates a change handler for status/option selection
 * @param {Function} setState - State setter function
 * @param {Function} resetState - Optional function to reset related state
 * @returns {Function} Change handler
 */
export const createStatusChangeHandler = (setState, resetState = null) => (value) => {
  try {
    setState(value);
    if (resetState) {
      resetState();
    }
  } catch (error) {
    console.error("Error in status change handler:", error);
  }
};

/**
 * Creates an input change handler that updates multiple states
 * @param {Function} setPrimaryState - Primary state setter
 * @param {Function} setSecondaryState - Secondary state setter (optional)
 * @returns {Function} Input change handler
 */
export const createInputChangeHandler = (setPrimaryState, setSecondaryState = null) => (event) => {
  try {
    const value = event.target.value;
    setPrimaryState(value);
    if (setSecondaryState) {
      setSecondaryState(value);
    }
  } catch (error) {
    console.error("Error in input change handler:", error);
  }
};
